import { render, staticRenderFns } from "./articleList.vue?vue&type=template&id=5bd8f1f8&scoped=true&"
import script from "./articleList.vue?vue&type=script&lang=js&"
export * from "./articleList.vue?vue&type=script&lang=js&"
import style0 from "./articleList.vue?vue&type=style&index=0&id=5bd8f1f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8f1f8",
  null
  
)

export default component.exports